import React from 'react';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Main from 'views/layouts/Main/Main';
import { AboutSlider, FAQContent, Partners, Team } from './components';

import SimContainer from 'components/SimContainer';
import { SimTypography } from 'components/SimTypography';
import SimLeaderQuote from 'components/SimLeaderQuote';

const About = () => {
	const theme = useTheme();

	return (
		<Main>
			<AboutSlider />

			<Box paddingTop={2} paddingBottom={2}>
				<SimContainer>
					{/* SECTION TITLE START */}
					<Box
						marginBottom={4}
						width={1}
						height={1}
						display={'flex'}
						flexDirection={'column'}
						alignItems={'center'}
						alignContent={'center'}
						boxShadow={0}>
						<SimTypography
							sx={{
								textTransform: 'uppercase',
								fontWeight: 'medium'
							}}
							gutterBottom
							color={'primary'}
							align={'center'}
							marginTop={12}>
							OUR TEAM
						</SimTypography>
						<SimTypography
							variant='h4'
							align={'center'}
							data-aos={'fade-up'}
							gutterBottom
							sx={{
								fontWeight: 700
							}}>
							Our care team brings together expertise, experience and empathy
						</SimTypography>
					</Box>
					{/* SECTION TITLE END */}
					<Team />
				</SimContainer>
			</Box>

			<Box bgcolor={'secondary.main'} marginTop={{ xs: '20vw', sm: '20vw', md: '5vw' }}>
				<SimContainer>
					<SimLeaderQuote />
				</SimContainer>
			</Box>

			<Box>
				<Box bgcolor={theme.palette.background.default}>
					<SimContainer padding={'0 !important'} maxWidth='1200px'>
						{/* SECTION TITLE START */}
						<Box
							paddingX={4}
							marginBottom={2}
							width={1}
							height={1}
							display={'flex'}
							flexDirection={'column'}
							alignItems={'center'}
							alignContent={'center'}
							boxShadow={0}>
							<SimTypography
								sx={{
									textTransform: 'uppercase',
									fontWeight: 'medium'
								}}
								gutterBottom
								color={theme.palette.primary.main}
								align={'center'}
								marginTop={12}>
								OUR DIFFERENCE
							</SimTypography>
							<SimTypography
								variant='h4'
								align={'center'}
								color={theme.palette.text.primary}
								data-aos={'fade-up'}
								gutterBottom
								sx={{
									fontWeight: 700
								}}>
								Why Choose Us?
							</SimTypography>
							<SimTypography
								variant='h6'
								align={'center'}
								color={theme.palette.text.primary}
								data-aos={'fade-up'}>
								While many clinics are available, most are inherently focused on quick fixes,
								<br />
								instead of taking a holistic approach towards the well-being of a child.
								<br />
								<br />
								Simple Souls was founded to do better.
							</SimTypography>
						</Box>
						{/* SECTION TITLE END */}

						<FAQContent />
					</SimContainer>
				</Box>
			</Box>

			<Box bgcolor={theme.palette.background.default}>
				<Box display='flex' justifyContent='center' alignItems='center' paddingY={6} maxwidth={400}>
					<SimContainer>
						<Box paddingX={4}>
							<Partners />
						</Box>
					</SimContainer>
				</Box>
			</Box>
		</Main>
	);
};

export default About ;
